import * as React from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { history } from 'utils/history';
import store, { RootState } from 'store';
import App from 'App';
import 'assets/styles/styles.scss';
import { config_getEnv } from 'store/config/actions';
import { connect } from 'react-redux';
import { config_loader } from 'store/config/selectors';
import { getAllSearchParamsAsObject } from 'helpers/urlParamaters';
import { IntercomProvider } from 'react-use-intercom';
import config from 'config/common';
import analyticsManager from 'helpers/analyticsManager';
import { mixPanelEventsTypes } from 'helpers/mixPanel';
import { ReviewedMixpanelEvents } from 'helpers/mixpanelReviewedEvents';
import Loader from 'components/Loader';
import LoaderFullScreen from 'components/LoaderFullScreen';

interface ShellProps {
    config_loader: boolean;
    config_getEnv: () => void;
}

const Shell = ({ config_getEnv, config_loader }: ShellProps) => {
    const handleIntercomeChange = (intercomeOpen: boolean) =>
        analyticsManager.trackEventGeneric(mixPanelEventsTypes.INTERCOM_INITIATED, {
            intercomeState: intercomeOpen ? 'opened' : 'closed',
            pageName: history.location.pathname,
        });

    React.useEffect(() => {
        config_getEnv();
    }, [config_getEnv]);

    React.useEffect(() => {
        const searchParamsAsObject = getAllSearchParamsAsObject();
        const notAllowedKeys = ['ssotoken', 'wttoken', 'crmtoken'];
        Object.keys(searchParamsAsObject).forEach((key) => {
            if (notAllowedKeys.some((naKey) => naKey === key.toLowerCase())) {
                delete searchParamsAsObject[key];
            }
        });

        analyticsManager.trackEvent(ReviewedMixpanelEvents.PAGE_LANDED, searchParamsAsObject);

        const handleAppInstalled = () => {
            analyticsManager.trackEvent(mixPanelEventsTypes.PWA_INSTALLED);
        };
        window.addEventListener('appinstalled', handleAppInstalled);
        return () => {
            window.removeEventListener('appinstalled', handleAppInstalled);
        };
    }, []);

    if (config_loader) return <LoaderFullScreen />;

    return (
        <IntercomProvider
            onHide={() => handleIntercomeChange(false)}
            onShow={() => handleIntercomeChange(true)}
            appId={config.intercomAppId}
        >
            <Router history={history}>
                <App />
            </Router>
        </IntercomProvider>
    );
};

const mapStateToProps = (state: RootState) => ({
    config_loader: config_loader(state),
});

const mapDispatchToProps = {
    config_getEnv,
};
const ShellWithStore = connect(mapStateToProps, mapDispatchToProps)(Shell);

const Root: React.FunctionComponent = () => {
    return (
        <Provider store={store}>
            <ShellWithStore />
        </Provider>
    );
};

export default Root;
